import * as React from "react";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";

import nl from 'date-fns/locale/nl';
import { Actions, ManageableQuickscanData } from "../types";
import { QuickscanDataContext } from "../context/QuickscanDataContext";

registerLocale('nl', nl);

export const StepTwo = () => {

    const [quickscanDataState, quickscanDataDispatch] = React.useContext<ManageableQuickscanData>(QuickscanDataContext);

    return <div className={'c-quickscan__form-group'}>
        <div className={'c-form__row'}>
            <div className={'c-quickscan__form-field'}>
                <label htmlFor="field-foundingdate" className={'c-form__label'}>Oprichtingsdatum</label>
                <DatePicker dateFormat={'dd/MM/yyyy'} showYearDropdown={true} id={'field-foundingdate'}
                            className={'c-form__field c-form__field--half c-form__input-text'} locale="nl"
                            selected={quickscanDataState.quickscan.foundingDate} onChange={(date) => {
                    if (date instanceof Date) {
                        quickscanDataDispatch({
                            type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                            payload: {
                                quickscan: {
                                    ...quickscanDataState.quickscan,
                                    foundingDate: date
                                }
                            }
                        })
                    }
                }}/>
            </div>

            <div
                className={`c-quickscan__form-field ${quickscanDataState.validation.fields.fte ? '' : 'c-form__field--invalid'}`}>
                <label htmlFor="field-fte" className="c-form__label">Aantal fte</label>
                <input type="text" id="field-fte" name="fte"
                       className={'c-form__field c-form__field--half c-form__input-text'}
                       value={Number.isNaN(quickscanDataState.quickscan.fte) ? 0 : quickscanDataState.quickscan.fte}
                       onChange={(e) => {
                           quickscanDataDispatch({
                               type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                               payload: {
                                   quickscan: {
                                       ...quickscanDataState.quickscan,
                                       fte: parseInt(e.target.value) || 0
                                   }
                               }
                           })
                       }}/>
            </div>
        </div>
        <div className={'c-form__row'}>
            <div
                className={`c-quickscan__form-field ${quickscanDataState.validation.fields.previousRevenue ? '' : 'c-form__field--invalid'}`}>
                <label htmlFor="field-previousrevenue" className="c-form__label">Omzet vorig jaar</label>
                <input type="text" id="field-previousrevenue" name="previousrevenue"
                       className={'c-form__field c-form__field--half c-form__input-text'}
                       value={Number.isNaN(quickscanDataState.quickscan.previousRevenue) ? 0 : quickscanDataState.quickscan.previousRevenue}
                       onChange={(e) => {
                           quickscanDataDispatch({
                               type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                               payload: {
                                   quickscan: {
                                       ...quickscanDataState.quickscan,
                                       previousRevenue: parseInt(e.target.value) || 0
                                   }
                               }
                           })
                       }}/>
            </div>

            <div
                className={`c-quickscan__form-field ${quickscanDataState.validation.fields.currentRevenue ? '' : 'c-form__field--invalid'}`}>
                <label htmlFor="field-currentrevenue" className="c-form__label">Verwachte omzet dit jaar</label>
                <input type="text" id="field-currentrevenue" name="currentrevenue"
                       className={'c-form__field c-form__field--half c-form__input-text'}
                       value={Number.isNaN(quickscanDataState.quickscan.currentRevenue) ? 0 : quickscanDataState.quickscan.currentRevenue}
                       onChange={(e) => {
                           quickscanDataDispatch({
                               type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                               payload: {
                                   quickscan: {
                                       ...quickscanDataState.quickscan,
                                       currentRevenue: parseInt(e.target.value) || 0
                                   }
                               }
                           })
                       }}/>
            </div>
        </div>
        <div className={'c-form__row'}>
            <div className={'c-quickscan__form-field--full c-quickscan__form-field '}>
                <label htmlFor="field-category" className="c-form__label">Categorie</label>
                <select id={'field-category'}
                        className="c-form__field c-form__field--half c-form__select c-form__input-text"
                        value={quickscanDataState.quickscan.category}
                        onChange={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                                payload: {
                                    quickscan: {
                                        ...quickscanDataState.quickscan,
                                        category: e.target.value
                                    }
                                }
                            })
                        }}>
                    <option>Agro/Food</option>
                    <option>Medical Device</option>
                    <option>Medicijnontwikkeling diagnostiek</option>
                    <option>Medicijnontwikkeling therapie</option>
                    <option>Witte biotech</option>
                    <option>Anders</option>
                </select>
            </div>
        </div>
        <div className={'c-form__row'}>
            <div className={`c-quickscan__form-field--full c-quickscan__form-field ${quickscanDataState.validation.fields.activities ? '' : 'c-form__field--invalid'}`}>
                <label htmlFor="field-activities" className="c-form__label">Omschrijving van de
                    bedrijfsactiviteiten</label>
                <textarea id="field-activities" name="activities"
                          className={`c-form__field c-form__field--full c-form__input-text c-form__textarea ${quickscanDataState.validation.fields.activities ? '' : 'c-form__field--invalid'}`}
                          defaultValue={quickscanDataState.quickscan.activities}
                          onChange={(e) => {
                              quickscanDataDispatch({
                                  type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                                  payload: {
                                      quickscan: {
                                          ...quickscanDataState.quickscan,
                                          activities: e.target.value
                                      }
                                  }
                              })
                          }}></textarea>
            </div>
        </div>
        <div className={'c-form__row'}>
            <div
                className={`c-quickscan__form-field--full c-quickscan__form-field ${quickscanDataState.validation.fields.innovation ? '' : 'c-form__field--invalid'}`}>
                <label htmlFor="field-innovation" className="c-form__label">Wat maakt jouw technologie innovatief in de
                    Life
                    Sciences? </label>
                <textarea id="field-innovation" name="innovation"
                          className={'c-form__field c-form__field--full c-form__input-text c-form__textarea'}
                          defaultValue={quickscanDataState.quickscan.innovation}
                          onChange={(e) => {
                              quickscanDataDispatch({
                                  type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                                  payload: {
                                      quickscan: {
                                          ...quickscanDataState.quickscan,
                                          innovation: e.target.value
                                      }
                                  }
                              })
                          }}></textarea>
            </div>
        </div>
        <div className={'c-form__row'}>
            <div
                className={`c-quickscan__form-field--full c-quickscan__form-field ${quickscanDataState.validation.fields.ip ? '' : 'c-form__field--invalid'}`}>
                <label htmlFor="field-ip" className="c-form__label">Op welke wijze is jouw intellectuele-eigendomsrecht
                    beschermd?</label>
                <textarea id="field-ip" name="ip"
                          className={'c-form__field c-form__field--full c-form__input-text c-form__textarea'}
                          defaultValue={quickscanDataState.quickscan.ip}
                          onChange={(e) => {
                              quickscanDataDispatch({
                                  type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                                  payload: {
                                      quickscan: {
                                          ...quickscanDataState.quickscan,
                                          ip: e.target.value
                                      }
                                  }
                              })
                          }}></textarea>
            </div>
        </div>
    </div>;
}
